import React from 'react';
import RadioComponent from "../RadioComponent";
import Tooltip from '../Tooltip';
import Label from "../Label";

const PressureHolderNeed = (props) => {
  const { name, parameters } = props;
  const onChange = e => props.onChangeParameter(name, e.target.value);
  const value = parameters[name];
  return (
    <div className="form-group">
      <Label label={props.label} required={props.required}>
        <Tooltip id={`tooltip-${props.name}`} title={props.tooltip} />
      </Label>
      <div className="radio-group">
        <RadioComponent
          {...props}
          checked={value === props.noValue}
          inline
          inputId="pressure-holder-need-no"
          inputClassName={props.inputClassName}
          label={props.noLabel}
          name={name}
          onChange={onChange}
          value={props.noValue} />
        <RadioComponent
          {...props}
          checked={value === props.yesValue}
          inline
          inputId="pressure-holder-need-yes"
          inputClassName={props.inputClassName}
          label={props.yesLabel}
          name={name}
          onChange={onChange}
          value={props.yesValue} />
        <div className="error-place" />
      </div>
      {props.children}
    </div>
  );
}

PressureHolderNeed.defaultProps = {
  name    : 'need_pressure_holder',
  label   : 'Do your boards need pressure holder?',
  yesLabel: 'Yes',
  yesValue: '1',
  noLabel : 'No',
  noValue : '0',
  required: true,
};

export default PressureHolderNeed;
